import { createSlice } from "@reduxjs/toolkit";
import { configureStore } from "@reduxjs/toolkit";
import axios from "axios";
const myreducer=createSlice({
    name:"myreducer",
    initialState:'',
    reducers:{
      addData(state,action){
        state=action.payload
        return state;
      }
    }
});
const store=configureStore({reducer:myreducer.reducer});
export default store;
export const action=myreducer.actions;

export const getData=()=>{
  return (dispatcher)=>{
    const output=()=>{
      axios.get("https://673cbd3d96b8dcd5f3fb6024.mockapi.io/emts2").then((success)=>{
        dispatcher(action.addData(success.data))
      }).catch((error)=>{
        dispatcher(action.addData(error))
      });
    }
    output();
  }
}